const getUserAgent = (context) => {
  let userAgent, isDesktop
  if (context.req) userAgent = context.req.headers['user-agent']
  else userAgent = window.navigator.userAgent
  if (userAgent)
    isDesktop = !userAgent.match(
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/
    )
  return { userAgent, isDesktop }
}

export default getUserAgent
